import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { I } from './Icons'

const Section = styled.section`
  margin-top: 28px;
`

const Card = styled.div`
  background: ${p => p.theme.colors.semantic.surface};
  border: 1px solid ${p => p.theme.colors.semantic.border};
  border-radius: 12px;
  box-shadow: ${p => p.theme.colors.semantic.shadowSm};
  padding: 0;
  overflow: hidden;
`

const NarrHead = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid ${p => p.theme.colors.semantic.border};
  gap: 12px;
`

const HeadT = styled.span`
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`

const Meta = styled.span`
  font-size: 12px;
  color: ${p => p.theme.colors.semantic.textMuted};
  margin-left: auto;
`

const RewriteBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  background: ${p => p.theme.colors.semantic.surfaceMuted};
  border: 1px solid ${p => p.theme.colors.semantic.border};
  color: ${p => p.theme.colors.semantic.textPrimary};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: ${p => p.theme.colors.semantic.lilacTint};
    color: ${p => p.theme.colors.semantic.accent};
    border-color: ${p => p.theme.colors.semantic.lilacLight};
  }
`

const NarrBody = styled.div`
  padding: 18px 22px;
  font-size: 14px;
  line-height: 1.65;
  color: ${p => p.theme.colors.semantic.textPrimary};
  p {
    margin: 0 0 12px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  .cited {
    background: linear-gradient(
      0deg,
      ${p => p.theme.colors.semantic.lilacTint},
      ${p => p.theme.colors.semantic.lilacTint}
    );
    padding: 0 3px;
    border-radius: 3px;
    border-bottom: 1px dashed ${p => p.theme.colors.semantic.accent};
  }
`

function renderInlineHtml(text) {
  let out = text
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
  out = out.replace(
    /(\$[\d,]+(?:\.\d+)?|\d+%|April\s\d+|May\s\d+|June\s\d+)/g,
    '<span class="cited">$1</span>',
  )
  return { __html: out }
}

const WipAiNarrativeEditor = ({ narrative = '', revLabel, lastEdited, onRewrite, readOnly }) => {
  const paragraphs = (narrative || '').split('\n\n').filter(Boolean)

  return (
    <Section id="narrative">
      <Card>
        <NarrHead>
          <HeadT>Summary</HeadT>
          <Meta>
            {revLabel} · last edited {lastEdited}
          </Meta>
          {!readOnly && (
            <RewriteBtn type="button" onClick={onRewrite}>
              <I.sparkle width={11} height={11} /> Rewrite with AI
            </RewriteBtn>
          )}
        </NarrHead>
        {paragraphs.length > 0 ? (
          <NarrBody>
            {paragraphs.map((para, i) => (
              <p key={i} dangerouslySetInnerHTML={renderInlineHtml(para)} />
            ))}
          </NarrBody>
        ) : (
          <NarrBody style={{ color: '#898989', fontStyle: 'italic' }}>
            Type your summary here, or ask the AI assistant to draft one from this month&apos;s
            numbers.
          </NarrBody>
        )}
      </Card>
    </Section>
  )
}

WipAiNarrativeEditor.propTypes = {
  narrative: PropTypes.string,
  revLabel: PropTypes.string.isRequired,
  lastEdited: PropTypes.string.isRequired,
  onRewrite: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
}

export default WipAiNarrativeEditor
